/**
 * AG Grid global setup — module registration, license, and style nonce.
 *
 * This file is a side-effect module imported by AGTable and AGServerTable.
 * By keeping it outside main.jsx, the entire ag-grid-enterprise bundle is
 * deferred until a page that actually renders a grid is loaded (all grid
 * pages are behind React.lazy boundaries).
 *
 * The guard ensures registration runs exactly once even when both
 * AGTable and AGServerTable are imported in the same chunk.
 */
import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

import { AG_ENTERPRISE_KEY } from './AGTable.utils';
import { cspNonce } from '../../utils/cspNonce';

let registered = false;

export function ensureAgGridSetup() {
  if (registered) return;
  registered = true;

  ModuleRegistry.registerModules([AllEnterpriseModule]);
  LicenseManager.setLicenseKey(AG_ENTERPRISE_KEY);
  provideGlobalGridOptions({ styleNonce: cspNonce });
}
